import React, { useState, useRef } from 'react';

import PropTypes from 'prop-types';
import Slider from 'react-slick';

import CustomerCasesCard from './customer-cases-card';

import '../../styles/revamp/referral-customer-cases.scss';

const CustomerCasesSection = (props) => {
  const { translations } = props;

  const sliderRef = useRef(null);
  const namesRef = useRef(null);

  const [activeSlide, setActiveSlide] = useState(0);

  const customerCasesSlider = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesPerScroll: 1,
    touchMove: false,
    swipe: false,
    focusOnSelect: false,
    asNavFor: namesRef.current,
    beforeChange: (current, next) => { setActiveSlide(next); },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const alignerNamesSlider = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesPerScroll: 1,
    touchMove: false,
    swipe: false,
    focusOnSelect: false,
    fade: true,
    asNavFor: sliderRef.current
  };

  const sliderContents = [
    {
      aligner: translations.cards.card1.aligner_name,
      price: translations.cards.card1.price,
      sets: translations.cards.card1.aligner_sets,
      visits: translations.cards.card1.clinic_visits,
      duration: translations.cards.card1.duration,
      beforeImage: '/img/referral/before-after/case1-before.png',
      afterImage: '/img/referral/before-after/case1-after.png'
    },
    {
      aligner: translations.cards.card2.aligner_name,
      price: translations.cards.card2.price,
      sets: translations.cards.card2.aligner_sets,
      visits: translations.cards.card2.clinic_visits,
      duration: translations.cards.card2.duration,
      beforeImage: '/img/referral/before-after/case2-before.png',
      afterImage: '/img/referral/before-after/case2-after.png'
    },
    {
      aligner: translations.cards.card3.aligner_name,
      price: translations.cards.card3.price,
      sets: translations.cards.card3.aligner_sets,
      visits: translations.cards.card3.clinic_visits,
      duration: translations.cards.card3.duration,
      beforeImage: '/img/referral/before-after/case3-before.png',
      afterImage: '/img/referral/before-after/case3-after.png'
    }
  ];

  return (
    <section className="customer-cases-section">
      <h2
        className="heading"
        data-key="referral::customer_cases_section::heading"
        data-lokalise=""
      >
        {translations.heading}
      </h2>
      <p
        className="description"
        data-key="referral::customer_cases_section::sub_heading"
        data-lokalise=""
      >
        {translations.sub_heading}
      </p>
      <Slider {...customerCasesSlider} className="customer-cases-slider" ref={sliderRef}>
        {sliderContents.map((content, index) => (<CustomerCasesCard content={content} index={index} />))}
      </Slider>
      <Slider {...alignerNamesSlider} className="aligner-names-slider" ref={namesRef}>
        {sliderContents.map((content, index) => (
          <>
            <div className="common-content-one">
              <span
                data-key={`referral::customer_cases_section::cards.card${index + 1}.aligner_name`}
                data-lokalise=""
              >
                {content.aligner}
              </span>
              {content.price && <span>&nbsp;|&nbsp;</span>}
              <span
                data-key={`referral::customer_cases_section::cards.card${index + 1}.price`}
                data-lokalise=""
              >
                {content.price}
              </span>
            </div>
            <div className="common-content-two">
              <span
                data-key={`referral::customer_cases_section::cards.card${index + 1}.sets`}
                data-lokalise=""
              >
                {content.sets}
              </span>
              <span>
                &nbsp;|&nbsp;
              </span>
              <span
                data-key={`referral::customer_cases_section::cards.card${index + 1}.visits`}
                data-lokalise=""
              >
                {content.visits}

              </span>
              <span>
                &nbsp;|&nbsp;
              </span>
              <span
                data-key={`referral::customer_cases_section::cards.card${index + 1}.duration`}
                data-lokalise=""
              >
                {content.duration}
              </span>
            </div>
          </>
        ))}
      </Slider>
      <div className="slider-arrows">
        <img
          src="/img/referral/chevron-right.svg"
          className={`slider-arrow slider-arrow-prev ${activeSlide === 0 ? 'disabled' : ''}`}
          data-gumlet="false"
          alt="prev-arrow"
          role="presentation"
          onClick={() => sliderRef.current.slickPrev()}
        />
        <img
          src="/img/referral/chevron-right.svg"
          className={`slider-arrow slider-arrow-next ${activeSlide === sliderContents.length - 1 ? 'disabled' : ''}`}
          data-gumlet="false"
          alt="next-arrow"
          role="presentation"
          onClick={() => sliderRef.current.slickNext()}
        />
      </div>
    </section>
  );
};

export default CustomerCasesSection;

CustomerCasesSection.propTypes = {
  translations: PropTypes.shape().isRequired
};
